import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteRhFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='RH' htmlFor='input-importeRh' md={12} />
      <Col md={12}>
        <Form.InputNumber id='input-importeRh' name='input-importeRh' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteRhFormGroup)
